import { Alert, IconButton, styled, Tooltip } from '@mui/material';

import { Colors } from 'Themes/colors';
import { createTimezoneMismatchMessage, isTimezoneMismatch } from 'Utils/timezoneUtils';

import { IconSizes, InfoIcon } from '@libs/shared/ui/icons';

const StyledAlert = styled(Alert)`
  margin-bottom: 8px;

  .MuiAlert-message {
    font-size: 0.875rem;
  }
`;

const InlineWarning = styled('span')`
  color: ${Colors.warning};
  font-size: 0.75rem;
  margin-left: 4px;
`;

type Props = {
  userTimezone?: string;
  variant?: 'alert' | 'inline' | 'tooltip';
  className?: string;
};

export const TimezoneWarning = ({
  userTimezone,
  variant = 'alert',
  className
}: Readonly<Props>) => {
  if (!userTimezone || !isTimezoneMismatch(userTimezone)) {
    return null;
  }

  const message = createTimezoneMismatchMessage(userTimezone);

  switch (variant) {
    case 'inline':
      return <InlineWarning className={className}>⚠️ Different timezone</InlineWarning>;

    case 'tooltip':
      return (
        <Tooltip title={message} arrow>
          <IconButton size="small" className={className}>
            <InfoIcon fontSize={IconSizes.small} color="warning" />
          </IconButton>
        </Tooltip>
      );

    case 'alert':
    default:
      return (
        <StyledAlert severity="info" variant="outlined" className={className}>
          {message}
        </StyledAlert>
      );
  }
};
